import { Tag } from "antd"
import { ReactComponent as DELETE } from "../../../assets/DeleteICON.svg"
import { ReactComponent as ARROWUP } from "../../../assets/ChevronLeft.svg"
import { ReactComponent as ARROWDOWN } from "../../../assets/ChevronRight.svg"
import { P } from "../../../auth/permissions"
import { Authorized } from "../../../components/authentication/Authorized"
import { Tour, TourStop, TourWeekday, TOUR_WEEKDAYS, PREVIEW_STATUS_COLOR, PREVIEW_STATUS_LABEL } from "../types"

type TourStopCardType = {
    stop: TourStop
    otherTours: Tour[]
    canEdit: boolean
    onRemove: () => void
    onMoveUp: () => void
    onMoveDown: () => void
    onChangeWeekday: (weekday: TourWeekday) => void
    onMoveToTour: (tourId: string, weekday: TourWeekday) => void
}

export default function TourStopCard(props: TourStopCardType) {
    const address = `${props.stop.object.adress.street} ${props.stop.object.adress.nr}, ${props.stop.object.adress.city}`

    return (
        <div className="bg-white rounded-default shadow-lg p-3 flex flex-col gap-2">
            <div className="flex justify-between gap-2 items-start">
                <div className="min-w-0">
                    <p className="font-semibold text-sm truncate" title={props.stop.object.objectIndication || address}>
                        {props.stop.object.objectIndication || address}
                    </p>
                    <p className="text-xs text-gray-500 line-clamp-2">{address}</p>
                </div>
                {props.canEdit && (
                    <Authorized allOf={[P.termine_management]}>
                        <DELETE className="w-5 h-5 shrink-0 cursor-pointer hover:text-error" onClick={props.onRemove} />
                    </Authorized>
                )}
            </div>
            <div className="flex flex-wrap gap-1">
                <Tag className="m-0" color={PREVIEW_STATUS_COLOR[props.stop.previewStatus]}>
                    {PREVIEW_STATUS_LABEL[props.stop.previewStatus]}
                </Tag>
                {props.stop.isAdHoc && (
                    <Tag className="m-0" color="purple">
                        Außerplanmäßig
                    </Tag>
                )}
            </div>
            {props.stop.adHocTask && <p className="text-xs text-gray-600">{props.stop.adHocTask.activity}</p>}
            {props.canEdit && (
                <Authorized allOf={[P.termine_management]}>
                    <div className="flex flex-wrap gap-1 items-center pt-1 border-t">
                        <button type="button" className="btn btn-ghost btn-xs px-1" title="Nach oben" onClick={props.onMoveUp}>
                            <ARROWUP className="w-4 h-4 rotate-90" />
                        </button>
                        <button type="button" className="btn btn-ghost btn-xs px-1" title="Nach unten" onClick={props.onMoveDown}>
                            <ARROWDOWN className="w-4 h-4 rotate-90" />
                        </button>
                        <select
                            className="select select-xs select-bordered grow min-w-0"
                            value={props.stop.weekday}
                            onChange={(event) => props.onChangeWeekday(Number(event.target.value) as TourWeekday)}>
                            {TOUR_WEEKDAYS.map((day) => (
                                <option key={day.value} value={day.value}>
                                    {day.short}
                                </option>
                            ))}
                        </select>
                    </div>
                    {props.otherTours.length > 0 && (
                        <select
                            className="select select-xs select-bordered w-full"
                            defaultValue=""
                            onChange={(event) => {
                                if (!event.target.value) return
                                props.onMoveToTour(event.target.value, props.stop.weekday)
                                event.target.value = ""
                            }}>
                            <option value="">Auf andere Tour…</option>
                            {props.otherTours.map((tour) => (
                                <option key={tour._id} value={tour._id}>
                                    {tour.name}
                                </option>
                            ))}
                        </select>
                    )}
                </Authorized>
            )}
        </div>
    )
}
